module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/chevronRightGray.7ad9a54b.svg";